import { useState as b, useRef as m, useCallback as w, useEffect as f } from "react";
const v = _ref => {
  let {
    tabButtons: s,
    selectedTabId: i,
    onSelectTab: d
  } = _ref;
  const [h, o] = b(!1),
    [S, r] = b(!1),
    t = m(null),
    u = s[0],
    c = s[s.length - 1],
    l = w(() => {
      if (!t.current) {
        r(!1), o(!1);
        return;
      }
      if (!(t.current.scrollWidth > t.current.offsetWidth)) {
        r(!1), o(!1);
        return;
      }
      i === c.props.id && r(!1), i === u.props.id && o(!1), i !== c.props.id && r(!0), i !== u.props.id && o(!0);
    }, [u.props.id, c.props.id, i]);
  return f(() => (window.addEventListener("resize", l), () => {
    window.removeEventListener("resize", l);
  }), [l]), f(() => {
    l();
  }, [l]), {
    isScrollLeftButtonVisible: h,
    isScrollRightButtonVisible: S,
    handleShiftButtonClick: a => {
      var p;
      const n = (p = t == null ? void 0 : t.current) == null ? void 0 : p.querySelector('button[aria-selected="true"]');
      if (a === "left") {
        const e = n == null ? void 0 : n.previousElementSibling;
        e == null || e.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start"
        }), d(e == null ? void 0 : e.id);
      }
      if (a === "right") {
        const e = n == null ? void 0 : n.nextElementSibling;
        e == null || e.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start"
        }), d(e == null ? void 0 : e.id);
      }
    },
    tabsContentRef: t
  };
};
v.displayName = "useScrollVisibility";
export { v as useScrollVisibility };